import * as React from "react";
import * as jwtDecode from "jwt-decode";
import { Redirect } from "react-router";

export interface Props {
  match: {
    params: {
      token: string;
    };
  };
}

export interface State {
  token: JsonToken | null;
}

interface JsonToken {}

export default class Token extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    let token: JsonToken | null;
    try {
      token = jwtDecode(props.match.params.token);
    } catch (e) {
      token = null;
    }
    this.state = { token };
  }

  render() {
    if (this.state.token == null) {
      return <Redirect to="/404" />;
    } else {
      return (
        <Redirect
          to={{
            pathname: "/set-password",
            state: { token: this.props.match.params.token }
          }}
        />
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/screens/Token/Token.tsx